module.exports = __webpack_public_path__ + "static/recipe_screen-7ddf17bec8def5745680dd1381f3a6d3.png";